import { useState } from "react";
import { toast } from "sonner";
import { FadeUp } from "@/components/Reveal";
import ZipCTA from "@/components/denim/ZipCTA";

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const submit = (e) => {
        e.preventDefault();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        toast.success("Welcome to the Journal — you're on the list.");
        setEmail("");
    };

    return (
        <section className="mx-auto w-full max-w-[1400px] px-5 py-24 md:px-8 md:py-32 lg:px-10">
            <FadeUp>
                <div
                    data-testid="newsletter-pocket"
                    style={{ backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
                    className="denim-bg relative mx-auto max-w-xl overflow-hidden rounded-t-md rounded-b-[64px] border border-white/10 shadow-2xl shadow-black/60"
                >
                    <div className="absolute inset-0 bg-obsidian/75" aria-hidden="true" />
                    <div
                        className="absolute inset-3 rounded-b-[52px] border-2 border-dashed border-gold/60"
                        aria-hidden="true"
                    />
                    <span className="rivet absolute left-5 top-5 z-10 h-5 w-5 rounded-full" aria-hidden="true" />
                    <span className="rivet absolute right-5 top-5 z-10 h-5 w-5 rounded-full" aria-hidden="true" />
                    <div className="relative z-10 px-8 pb-16 pt-12 text-center">
                        <p className="flex items-center justify-center gap-3 text-[11px] font-mono uppercase tracking-[0.3em] text-gold">
                            <span className="stitch-x inline-block w-10" />
                            Join the Journal
                        </p>
                        <h2 className="mx-auto mt-4 max-w-sm font-display text-3xl font-bold uppercase leading-tight tracking-tight text-ink md:text-4xl">
                            First Access, Always
                        </h2>
                        <p className="mx-auto mt-4 max-w-xs text-sm leading-relaxed text-mute">
                            Drops, restocks and journal stories — slipped into your pocket before anyone else.
                        </p>
                        <form
                            onSubmit={submit}
                            data-testid="newsletter-form"
                            className="mx-auto mt-9 flex max-w-sm flex-col gap-3 sm:flex-row"
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Your email address"
                                data-testid="newsletter-input"
                                className="flex-1 border border-white/15 bg-coal px-5 py-4 text-sm text-ink placeholder:text-mute/50 focus:border-gold focus:outline-none"
                            />
                            <ZipCTA type="submit" testid="newsletter-submit">
                                Join
                            </ZipCTA>
                        </form>
                    </div>
                </div>
            </FadeUp>
        </section>
    );
}
